export enum ResolutionType {
  WAIT_FOR_RESTOCK = 1,
  REMOVE,
  SUBSTITUTE,
  ACKNOWLEDGED,
  UNUSUAL_QUANTITY,
  PRICE,
  DATE,
  ADD_TO_WAITLIST,
}
